import React from 'react';
import { FormattedMessage } from 'react-intl';
import Footer from '@dnb/footer';
import Header from '@dnb/header';
import { PageLayout, SimpleHeader } from '@pm-netbank/page-layout';
import { translationKeys } from '@pm-netbank/translations';

interface FormContainerProps {
  children: React.ReactNode;
}

function FormContainer({ children }: FormContainerProps) {
  return (
    <>
      <Header />
      <PageLayout narrow>
        <PageLayout.Header>
          <SimpleHeader
            title={
              <FormattedMessage
                id={translationKeys.becomeCustomer.become_customer_title}
              />
            }
          />
        </PageLayout.Header>
        <PageLayout.Content>{children}</PageLayout.Content>
      </PageLayout>
      <Footer />
    </>
  );
}

export default FormContainer;
